const getEditor = () => window.editor;

export default getEditor;


// WEBPACK FOOTER //
// ./src/utils/editor-utils.js